module.exports = __webpack_public_path__ + "img/9788980403783.266e5386.jpg";